import { useQuery } from "@tanstack/react-query"
import { getContactFormMessages } from "api/contactFormApi"

import { useEffect } from "react"

export const VEHICLE_STOCK_QUERY_KEY = "contact-form"

// Fetch all vehicle stocks with optional params (pagination, filters)
export const useContactFormMessages = (params = {}, enabled = true) => {
  const query = useQuery({
    queryKey: [VEHICLE_STOCK_QUERY_KEY, "message"], // stable key
    queryFn: () => getContactFormMessages(params),
    keepPreviousData: true,
    enabled,
  })

  // Whenever params changes, force a refetch
  useEffect(() => {
    if (enabled) query.refetch()
  }, [params, enabled])

  return query
}
